import { render, staticRenderFns } from "./escapeRecord.vue?vue&type=template&id=32f1e6d8&scoped=true"
import script from "./escapeRecord.vue?vue&type=script&lang=js"
export * from "./escapeRecord.vue?vue&type=script&lang=js"
import style0 from "./escapeRecord.vue?vue&type=style&index=0&id=32f1e6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1e6d8",
  null
  
)

export default component.exports